import React, {useState} from "react";
import {Dialog, DialogActions, DialogContent} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import CreationTypeSelection from "./CreationTypeSelection";
import FromScratch from "./FromScratch";
import FromTemplate from "./FromTemplate";

const CreateNew = ({isOpen, onClose}) => {
    const [selectedType, setSelectedType] = useState();
    const [activeScreen, setActiveScreen] = useState('selectTemplate');

    const Component = {
        'selectTemplate': <CreationTypeSelection
            setSelectedType={setSelectedType}
            selectedType={selectedType}
        />,
        'scratch': <FromScratch/>,
        'template': <FromTemplate/>
    }

    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth={"md"} fullWidth={true}>
            <DialogTitle><Typography variant={'body1'}>New application</Typography></DialogTitle>
            <DialogContent style={{padding: 0}} dividers={true}>
                {Component[activeScreen]}
            </DialogContent>
            <DialogActions style={{padding: '20px 15px'}}>
                {activeScreen !== 'selectTemplate' && (
                    <Button variant={"contained"} color={'default'} style={{width: 130, marginRight: 10}} size={'small'}
                            onClick={() => setActiveScreen('selectTemplate')}
                    >
                        Back
                    </Button>
                )}
                <Button variant={"contained"} color={'primary'} style={{width: 130}} size={'small'}
                        disabled={!Boolean(selectedType)}
                        onClick={() => setActiveScreen(selectedType)}
                >
                    {activeScreen === 'selectTemplate' ? "Next" : "Create"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
export default CreateNew

CreateNew.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
}